'use strict';

exports.__esModule = true;
var executeIfFunction = function executeIfFunction(f) {
  return typeof f === 'function' ? f() : f;
};

var switchcase = exports.switchcase = function switchcase(cases) {
  return function (defaultCase) {
    return function (key) {
      return key in cases ? cases[key] : defaultCase;
    };
  };
};

var switchcaseF = exports.switchcaseF = function switchcaseF(cases) {
  return function (defaultCase) {
    return function (key) {
      return executeIfFunction(switchcase(cases)(defaultCase)(key));
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bic-fe/mds-ui/dist/_util/switchcase.js
// module id = vxR+
// module chunks = 0